export const Fav_icon = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.325 8.7751L38.725 17.5751C39.325 18.8001 40.925 19.9751 42.275 20.2001L50.25 21.5251C55.35 22.3751 56.55 26.0751 52.875 29.7251L46.675 35.9251C45.625 36.9751 45.05 39.0001 45.375 40.4501L47.15 48.1251C48.55 54.2001 45.325 56.5501 39.95 53.3751L32.475 48.9501C31.125 48.1501 28.9 48.1501 27.525 48.9501L20.05 53.3751C14.7 56.5501 11.45 54.1751 12.85 48.1251L14.625 40.4501C14.95 39.0001 14.375 36.9751 13.325 35.9251L7.125 29.7251C3.475 26.0751 4.65 22.3751 9.75 21.5251L17.725 20.2001C19.05 19.9751 20.65 18.8001 21.25 17.5751L25.65 8.7751C28.05 4.0001 31.95 4.0001 34.325 8.7751Z"
      stroke="white"
      strokeWidth="3.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);